class TextCollapsed {
    constructor(el) {
        this.el = el;
        this.spanExpand = this.el.querySelector(".js-expand-text");
        this.expandText();
    }

    expandText() {
        this.spanExpand.addEventListener("click", () => {
            this.el.classList.add("is-expand");
        });
    }
}

window.addEventListener(
    "load",
    document
        .querySelectorAll(".js-text-collapsed")
        .forEach(node => new TextCollapsed(node))
);